module.exports = __webpack_public_path__ + "static/media/dna-onlyLogo.cdc5bab2.svg";